import { Link, NavLink, useLocation } from "react-router-dom";
import { LOGO_URL } from "../lib/api";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }) =>
    `text-overline transition-colors ${
      isActive ? "text-amber-500" : "text-stone-300 hover:text-stone-50"
    }`;

  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 left-0 right-0 z-50 bg-stone-950 border-b border-stone-800/60"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16 flex items-center justify-between h-20 sm:h-24">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img
            src={LOGO_URL}
            alt="Wood by ZQ"
            className="h-16 w-16 sm:h-20 sm:w-20 object-contain logo-invert"
          />
        </Link>

        <div className="hidden md:flex items-center gap-10">
          <NavLink to="/" end data-testid="nav-home" className={linkClass}>
            Home
          </NavLink>
          <NavLink to="/shop" data-testid="nav-shop" className={linkClass}>
            Shop
          </NavLink>
          <NavLink to="/instruments" data-testid="nav-instruments" className={linkClass}>
            Instruments
          </NavLink>
          <NavLink to="/custom" data-testid="nav-custom" className={linkClass}>
            Custom Builds
          </NavLink>
          <NavLink to="/about" data-testid="nav-about" className={linkClass}>
            About
          </NavLink>
          <Link
            to="/custom"
            data-testid="nav-cta"
            className="bg-amber-700 hover:bg-amber-600 text-stone-50 px-6 py-3 text-overline transition-colors"
          >
            Start a project
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          className="md:hidden text-stone-50 p-2"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-stone-950/95 backdrop-blur-xl border-t border-stone-800/60"
        >
          <div className="flex flex-col px-6 py-6 gap-5">
            <NavLink to="/" end className={linkClass} data-testid="m-nav-home">
              Home
            </NavLink>
            <NavLink to="/shop" className={linkClass} data-testid="m-nav-shop">
              Shop
            </NavLink>
            <NavLink to="/instruments" className={linkClass} data-testid="m-nav-instruments">
              Instruments
            </NavLink>
            <NavLink to="/custom" className={linkClass} data-testid="m-nav-custom">
              Custom Builds
            </NavLink>
            <NavLink to="/about" className={linkClass} data-testid="m-nav-about">
              About
            </NavLink>
            <Link
              to="/custom"
              data-testid="m-nav-cta"
              className="bg-amber-700 hover:bg-amber-600 text-stone-50 px-6 py-3 text-overline w-fit"
            >
              Start a project
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
